import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { STATS } from "../../config/landingConfig";
import { Reveal } from "./Reveal";

const CARDS = [
  { bg: "bg-cyan", value: "text-ink", label: "text-ink/75" },
  { bg: "bg-magenta", value: "text-white", label: "text-white/85" },
  { bg: "bg-violet", value: "text-white", label: "text-white/85" },
];

const Counter = ({ to, prefix = "", suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.6,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref} data-testid={`counter-${to}`}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
};

export const Credibility = () => (
  <section data-testid="credibility-section" className="border-b-4 border-ink bg-white">
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
      <Reveal>
        <p className="text-center text-xs font-extrabold uppercase tracking-[0.2em] text-ink/60">
          Kurs prowadzi praktyk - Anna Popławska
        </p>
      </Reveal>
      <div className="mt-8 grid gap-5 sm:grid-cols-3">
        {STATS.map((stat, i) => (
          <Reveal key={stat.label} delay={i * 0.1}>
            <div
              data-testid={`stat-card-${i}`}
              className={`hover-lift rounded-3xl border-2 border-ink px-6 py-7 text-center shadow-hard ${CARDS[i].bg}`}
            >
              <p className={`font-display text-4xl sm:text-5xl ${CARDS[i].value}`}>
                <Counter to={stat.value} prefix={stat.prefix} suffix={stat.suffix} />
              </p>
              <p className={`mt-2 text-sm font-bold ${CARDS[i].label}`}>{stat.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
